import actions from './actions';

const state = {
  query: [],
  path: ''
};
const mutations = {
  setQuery: (state, queryString) => {
    state.query = [...state.query, queryString];
  },
  setPath: (state, path) => {
    state.path = path;
  },
  flushQuery: (state) => {
    state.query = [];
  }
};
const getters = {
  getQuery: (state) => state.query,
  getPath: (state) => state.path
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
